import Vue from 'vue'
import Vuex from 'vuex'

import param from './modules/param'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    param
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js